import React, { useReducer } from 'react'

const initialState = {
  current: null,
}
const PlayerContext = React.createContext()

function reducer(state, action) {
  switch (action.type) {
    case 'setCurrent':
      console.log(action)
      return { current: action.current }
    default:
      return state
  }
}

const PlayerContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return <PlayerContext.Provider value={{ state, dispatch }}>{props.children}</PlayerContext.Provider>
}

export { reducer, PlayerContext, PlayerContextProvider }
